import { LocalDate, LocalTime } from '@js-joda/core';
import { useAsyncFn } from 'react-use';

import {
   Appointment,
   AppointmentOutOfUpdatingOrRemovingAvailabilityQuery,
} from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { CqrsQueryPerformResult, performCqrsQueryFindFirst } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { Range, Slot } from '@dreryk/watermelon';

export type PerformAppointmentForAvailabilityUpdateCqrsQueryParameters = {
   availabilityId: number;
   updateSingleOccurrence: boolean;
   selectedAvailabilityDate: LocalDate;
   newStartTime?: LocalTime;
   newEndTime?: LocalTime;
};

const pagination = paginations.first<Appointment>();

export type UsePerformAppointmentOutOfUpdatingOrRemovingAvailabilityCqrsQueryReturn = {
   appointment: Appointment | null;
   fetchData: (parameters: PerformAppointmentForAvailabilityUpdateCqrsQueryParameters) => Promise<Appointment | null>;
};

export const usePerformAppointmentOutOfUpdatingOrRemovingAvailabilityCqrsQuery = (
   practitionerId: PractitionerId
): UsePerformAppointmentOutOfUpdatingOrRemovingAvailabilityCqrsQueryReturn => {
   const performAppointmentOutOfUpdatingOrRemovingAvailability = async (
      parameters: PerformAppointmentForAvailabilityUpdateCqrsQueryParameters
   ): CqrsQueryPerformResult<Appointment | null> =>
      performCqrsQueryFindFirst(
         () => {
            const query = new AppointmentOutOfUpdatingOrRemovingAvailabilityQuery();
            if (parameters) {
               query.availabilityId = parameters.availabilityId;
               query.fromRecurrenceDate = Slot.of(parameters.selectedAvailabilityDate);
               query.singleOccurrence = parameters.updateSingleOccurrence;
               query.practitionerId = practitionerId;

               if (parameters.newStartTime && parameters.newEndTime) {
                  // TODO DREGAB-6353 Fix types
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  query.newTimeRange = Slot.of(Range.closedOpen(parameters.newStartTime, parameters.newEndTime));
               }
            }
            return query;
         },
         pagination,
         { cacheTime: 'never', staleTime: 'never' }
      );

   const [{ value: appointment }, fetchData] = useAsyncFn(performAppointmentOutOfUpdatingOrRemovingAvailability);

   return {
      appointment: appointment ?? null,
      fetchData: fetchData,
   };
};
